import React from "react";
import "./styles.css";

const Header = () => (
  <header style={{ marginTop: "150px" }} className="home-header">
    <h2>Supriya Ghosh </h2>
    <h1>
      <span>“</span> Artist ✍️ <span>”</span>
    </h1>
    <p>Mumbai calligrapher and engraver</p>
  </header>
);

export default Header;
